/**
 * 套餐名称工具（新需求81 / 修复 新需求82）
 *
 * 套餐重命名规则（最终版）：
 *   旧值                  →  新值（完整字符串，含括号备注，作为存储与显示统一值）
 *   校内考专家 1+2        →  校内考专家 1（原 1+2）
 *   校内考专家 1+2+3      →  校内考专家 1+2（原 1+2+3）
 *   丁老师规划 1+2        →  丁老师规划 1（原 1+2）
 *   丁老师规划 1+2+3      →  丁老师规划 1+2（原 1+2+3）
 *   私塾 / VIP            →  不变
 *
 * 【重要】为何采用「完整字符串」做存储 value：
 *   旧名「校内考专家 1+2」与重命名后的中间名「校内考专家 1+2」字面完全相同，
 *   无法仅靠字符串区分。因此把括号备注 `（原 1+2+3）` 写入存储值，
 *   让新值与旧值在字面上不再冲突，select.value 与显示文本一致。
 */

// 新版完整套餐选项（select 的 value 与显示文本一致）
export const PACKAGE_OPTIONS = [
  '私塾',
  '校内考专家 1（原 1+2）',
  '校内考专家 1+2（原 1+2+3）',
  '丁老师规划 1（原 1+2）',
  '丁老师规划 1+2（原 1+2+3）',
  'VIP',
];

// 旧（含历史中间态）→ 新完整字符串 的归一化映射
// 注意：键里既包含「原始旧名」(如 校内考专家 1+2)，也包含上一轮 81 错误归一化产生的「中间值」(如 校内考专家 1)
const LEGACY_TO_FINAL_MAP = {
  // 上一轮 81 之前的原始旧名
  '校内考专家 1+2+3': '校内考专家 1+2（原 1+2+3）',
  '丁老师规划 1+2+3': '丁老师规划 1+2（原 1+2+3）',
  // 既是「上一轮 81 之前的原始旧名」也是「上一轮 81 错误归一化后写回的中间值」
  '校内考专家 1+2': '校内考专家 1（原 1+2）',
  '丁老师规划 1+2': '丁老师规划 1（原 1+2）',
  // 上一轮 81 错误归一化后写回的中间值（仅前端显示态，但若用户在 81 之后保存过则可能落库）
  '校内考专家 1': '校内考专家 1（原 1+2）',
  '丁老师规划 1': '丁老师规划 1（原 1+2）',
};

/**
 * 把任意（含历史/中间态）套餐值归一化到「完整字符串」新值，便于保存与比较。
 * 如果已经是完整新值（在 PACKAGE_OPTIONS 中）或不在映射里（如 私塾/VIP），原样返回。
 */
export function normalizePackageName(name) {
  if (!name) return '';
  if (PACKAGE_OPTIONS.includes(name)) return name;
  return LEGACY_TO_FINAL_MAP[name] || name;
}

/**
 * 用于 UI 展示的套餐显示名：
 *  - 完整新值：直接返回（已含「（原 X）」备注）
 *  - 旧/中间态：先归一化再返回
 *  - 私塾/VIP/未知值：原样返回
 */
export function getPackageDisplayName(name) {
  return normalizePackageName(name);
}

/**
 * 下拉框选项（{ value, label }），value 与 label 完全一致（即完整新值），无歧义。
 */
export function getPackageSelectOptions() {
  return PACKAGE_OPTIONS.map(opt => ({ value: opt, label: opt }));
}
